<template>
  <div>
    <div v-for="(item, i) in count" :key="i" class="skeleton page-container page-container--rendered-blocks" :class="{'hidden-opacity': !isShowedSkeletons}">
      <content-loader
        class="skeleton-desktop"
        :width="1366"
        :height="476"
        :speed="2"
        primaryColor="#d9d9d9"
        secondaryColor="#f8f8f8"
      >
        <rect x="0"
              y="0"
              rx="3"
              ry="3"
              width="300"
              height="30" />
        <rect x="0"
              y="58"
              rx="3"
              ry="3"
              width="102"
              height="40" />
        <rect x="112"
              y="58"
              rx="3"
              ry="3"
              width="102"
              height="40" />
        <rect x="225"
              y="58"
              rx="3"
              ry="3"
              width="166"
              height="40" />
        <rect x="403"
              y="58"
              rx="3"
              ry="3"
              width="123"
              height="40" />
        <rect x="538"
              y="58"
              rx="3"
              ry="3"
              width="148"
              height="40" />
        <rect x="698"
              y="58"
              rx="3"
              ry="3"
              width="130"
              height="40" />
        <rect x="840"
              y="58"
              rx="3"
              ry="3"
              width="116"
              height="40" />
        <rect x="968"
              y="58"
              rx="3"
              ry="3"
              width="140"
              height="40" />
        <rect x="1120"
              y="58"
              rx="3"
              ry="3"
              width="200"
              height="40" />
        <rect x="300"
              y="376"
              rx="3"
              ry="3"
              width="230"
              height="18" />
        <rect x="300"
              y="406"
              rx="3"
              ry="3"
              width="138"
              height="18" />
        <rect x="300"
              y="448"
              rx="3"
              ry="3"
              width="122"
              height="28" />
        <rect x="300"
              y="142"
              rx="3"
              ry="3"
              width="219"
              height="206" />
        <rect x="21"
              y="376"
              rx="3"
              ry="3"
              width="230"
              height="18" />
        <rect x="21"
              y="406"
              rx="3"
              ry="3"
              width="138"
              height="18" />
        <rect x="21"
              y="448"
              rx="3"
              ry="3"
              width="122"
              height="28" />
        <rect x="21"
              y="142"
              rx="3"
              ry="3"
              width="219"
              height="206" />
        <rect x="578"
              y="376"
              rx="3"
              ry="3"
              width="230"
              height="18" />
        <rect x="578"
              y="406"
              rx="3"
              ry="3"
              width="138"
              height="18" />
        <rect x="578"
              y="448"
              rx="3"
              ry="3"
              width="122"
              height="28" />
        <rect x="578"
              y="142"
              rx="3"
              ry="3"
              width="219"
              height="206" />
        <rect x="857"
              y="376"
              rx="3"
              ry="3"
              width="230"
              height="18" />
        <rect x="857"
              y="406"
              rx="3"
              ry="3"
              width="138"
              height="18" />
        <rect x="857"
              y="448"
              rx="3"
              ry="3"
              width="122"
              height="28" />
        <rect x="857"
              y="142"
              rx="3"
              ry="3"
              width="219"
              height="206" />
        <rect x="1136"
              y="376"
              rx="3"
              ry="3"
              width="230"
              height="18" />
        <rect x="1136"
              y="406"
              rx="3"
              ry="3"
              width="138"
              height="18" />
        <rect x="1136"
              y="448"
              rx="3"
              ry="3"
              width="122"
              height="28" />
        <rect x="1136"
              y="142"
              rx="3"
              ry="3"
              width="219"
              height="206" />
      </content-loader>
      <content-loader
        class="skeleton-tablet"
        :width="753"
        :height="597"
        :speed="2"
        primaryColor="#d9d9d9"
        secondaryColor="#f8f8f8"
      >
        <rect x="0"
              y="0"
              rx="3"
              ry="3"
              width="300"
              height="30" />
        <rect x="0"
              y="65"
              rx="3"
              ry="3"
              width="141"
              height="38" />
        <rect x="469"
              y="65"
              rx="3"
              ry="3"
              width="141"
              height="38" />
        <rect x="156"
              y="65"
              rx="3"
              ry="3"
              width="141"
              height="38" />
        <rect x="626"
              y="65"
              rx="3"
              ry="3"
              width="127"
              height="38" />
        <rect x="313"
              y="65"
              rx="3"
              ry="3"
              width="141"
              height="38" />
        <rect x="277"
              y="572"
              rx="3"
              ry="3"
              width="185"
              height="25" />
        <rect x="15"
              y="404"
              rx="3"
              ry="3"
              width="245"
              height="20" />
        <rect x="15"
              y="436"
              rx="3"
              ry="3"
              width="147"
              height="20" />
        <rect x="15"
              y="480"
              rx="3"
              ry="3"
              width="130"
              height="29" />
        <rect x="15"
              y="141"
              rx="3"
              ry="3"
              width="232"
              height="232" />
        <rect x="293"
              y="404"
              rx="3"
              ry="3"
              width="245"
              height="20" />
        <rect x="293"
              y="436"
              rx="3"
              ry="3"
              width="147"
              height="20" />
        <rect x="293"
              y="480"
              rx="3"
              ry="3"
              width="130"
              height="29" />
        <rect x="293"
              y="141"
              rx="3"
              ry="3"
              width="232"
              height="232" />
        <rect x="573"
              y="404"
              rx="3"
              ry="3"
              width="180"
              height="19" />
        <rect x="573"
              y="436"
              rx="3"
              ry="3"
              width="147"
              height="20" />
        <rect x="573"
              y="480"
              rx="3"
              ry="3"
              width="130"
              height="29" />
        <rect x="573"
              y="141"
              rx="3"
              ry="3"
              width="180"
              height="232" />
      </content-loader>
      <content-loader
        class="skeleton-mobile"
        :width="345"
        :height="571"
        :speed="2"
        primaryColor="#d9d9d9"
        secondaryColor="#f8f8f8"
      >
        <rect x="0"
              y="0"
              rx="3"
              ry="3"
              width="230"
              height="25" />
        <rect x="0"
              y="65"
              rx="3"
              ry="3"
              width="112"
              height="30" />
        <rect x="122"
              y="65"
              rx="3"
              ry="3"
              width="112"
              height="30" />
        <rect x="243"
              y="65"
              rx="3"
              ry="3"
              width="112"
              height="30" />
        <rect x="73"
              y="546"
              rx="3"
              ry="3"
              width="185"
              height="25" />
        <rect x="15"
              y="404"
              rx="3"
              ry="3"
              width="245"
              height="20" />
        <rect x="15"
              y="436"
              rx="3"
              ry="3"
              width="147"
              height="20" />
        <rect x="15"
              y="480"
              rx="3"
              ry="3"
              width="130"
              height="29" />
        <rect x="15"
              y="141"
              rx="3"
              ry="3"
              width="232"
              height="232" />
        <rect x="293"
              y="404"
              rx="3"
              ry="3"
              width="245"
              height="20" />
        <rect x="293"
              y="436"
              rx="3"
              ry="3"
              width="147"
              height="20" />
        <rect x="293"
              y="480"
              rx="3"
              ry="3"
              width="130"
              height="29" />
        <rect x="293"
              y="141"
              rx="3"
              ry="3"
              width="232"
              height="232" />
      </content-loader>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductsSliderSkeleton',
  components: {
    ContentLoader
  },
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isShowedSkeletons'])
  }
}
</script>

<style scoped lang="sass">

.skeleton
  padding-top: 30px

  +mmin($tablet)
    padding-top: 60px

.skeleton-desktop
  display: none

  +mmin($tablet--hor)
    display: block

.skeleton-tablet
  display: none

  +mmin($tablet)
    display: block

  +mmin($tablet--hor)
    display: none

.skeleton-mobile
  display: block

  +mmin($tablet)
    display: none

</style>
